<template>
  <div>
    <el-container>
      <!-- 顶部 -->
      <el-header>
        <div>
          <div class="bamtopclass">管理员后台管理</div>

          <div class="removeLogin">
            <el-button type="primary" @click="outlogin"> 退出登录</el-button>
          </div>
          <div><span class="username">{{ username }}</span></div>
        </div>



      </el-header>
      <el-container class="home_class">
        <el-aside width="200px">
          <!-- 左侧 -->
          <el-menu router>

            <!-- 一级菜单 -->
            <el-submenu index="1">
              <!-- 一级菜单模块区域 -->
              <template slot="title">
                <!-- 图标 -->
                <span class="iconfont icon-xinwen"></span>
                <span>新闻管理</span>
              </template>
              <!-- 二级菜单 -->
              <el-menu-item-group>
                <el-menu-item index="getnews">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-xinwenliebiao-02"></span>
                    <span @click="newscli">新闻列表</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>

            </el-submenu>

            <!-- 一级菜单 -->
            <el-submenu index="2">
              <!-- 一级菜单模块区域 -->
              <template slot="title">
                <!-- 图标 -->
                <span class="iconfont icon-yonghu"></span>
                <span>用户管理</span>
              </template>
              <!-- 二级菜单 -->
              <el-menu-item-group>
                <el-menu-item index="adminUser">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-yonghuguanli"></span>
                    <span>管理员用户</span>
                  </template>
                </el-menu-item>

              </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item index="LoginUserList">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-yonghuguanli"></span>
                    <span>在线用户</span>
                  </template>
                </el-menu-item>

              </el-menu-item-group>
              <!-- 二级菜单 -->
              <el-menu-item-group>
                <el-menu-item index="viewStudentBam">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-yonghuguanli"></span>
                    <span>学生管理</span>
                  </template>
                </el-menu-item>

              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="3">
              <!-- 一级菜单模块区域 -->
              <template slot="title">
                <!-- 图标 -->
                <span class="iconfont icon-daohanglan"></span>
                <span>导航栏管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="OneNavigation">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-xinzeng"></span>
                    <span>一级导航栏页面</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
              <!-- 二级菜单 -->
              <el-menu-item-group>
                <el-menu-item index="navigation">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-xinzeng"></span>
                    <span>二级导航栏页面</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item index="ThreeNavigation">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-xinzeng"></span>
                    <span>三级导航栏管理</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item index="FourNavigation">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-xinzeng"></span>
                    <span>四级导航栏管理</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <!-- 一级菜单 -->
            <el-submenu index="5">
              <!-- 一级菜单模块区域 -->
              <template slot="title">
                <!-- 图标 -->
                <span class="iconfont icon-daohanglan"></span>
                <span>首页</span>
              </template>
              <!-- 二级菜单 -->
              <el-menu-item-group>
                <el-menu-item index="HomePage">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-daohanglan"></span>
                    <span>首页轮播管理</span>
                  </template>
                </el-menu-item>

              </el-menu-item-group>

            </el-submenu>
            <!-- 一级菜单 -->
            <el-submenu index="6">
              <!-- 一级菜单模块区域 -->
              <template slot="title">
                <!-- 图标 -->
                <span class="iconfont icon-daohanglan"></span>
                <span>公告管理</span>
              </template>
              <!-- 二级菜单 -->
              <el-menu-item-group>
                <el-menu-item index="Announcement">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-daohanglan"></span>
                    <span>添加公告</span>
                  </template>
                </el-menu-item>

              </el-menu-item-group>

            </el-submenu>
<!-- 
            <el-submenu index="20">
        <template slot="title">
         <span class="iconfont icon-gerenxinxi1"></span>
          <span>调查问卷</span>
        </template>
    
              <el-menu-item-group>
          <el-menu-item index="Questionnaire">
             <template slot="title">
          <span class="iconfont icon-yonghuguanli"></span>
          <span>调查问卷</span>
        </template>
          </el-menu-item>
        
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="ViewQuestionnaire">
             <template slot="title">
          <span class="iconfont icon-yonghuguanli"></span>
          <span>调查问卷查看</span>
        </template>
          </el-menu-item>
        
        </el-menu-item-group>
      </el-submenu> -->
          </el-menu>

        </el-aside>

        <el-container>
          <el-main>

            <router-view></router-view>

          </el-main>
          <el-footer>Footer</el-footer>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>

export default {
  created() {
    this.newscli()
  },
  methods: {
    newscli() {
      this.username = JSON.parse(localStorage.getItem('user')).username
    },
    outlogin() {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      this.$router.push({
        name: 'Login',
      })
    },
    data() {
      return {
        username: ''
      }
    }
  }

}
</script>

<style scoped lang="less">
.el-header,
.el-footer {
  background-color: #B3C0D1;
  color: #333;
  text-align: center;
  line-height: 60px;
  min-width: 1400px;
}

.el-aside {
  background-color: #D3DCE6;
  color: #333;

  line-height: 200px;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
  // text-align: center;
  min-width: 1200px;
}

.home_class {
  height: 800px;
}

.removeLogin {
  float: right;
}

.bamtopclass {
  float: left;
  padding-left: 45%;
}

/* .el-submenu__title{
  margin-left: -80px;
 } */
.username {
  padding-left: 38%;
}

</style>


// WEBPACK FOOTER //
// src/components/work/bam.vue